const actionTypes = require('constants/actionTypes');

const setProcessSelected = (payload) => ({
    type: actionTypes.SET_PROCESS_SELECTED,
    payload
});

const resetProcessSelected = () => ({
    type: actionTypes.RESET_PROCESS_SELECTED,
});

const increaseDocumentsUploadedAction = () => ({
    type: actionTypes.INCREASE_DOCUMENTS_UPLOADED,
});

const saveProcessSelected = (processSelected) => (dispatch) => {
    dispatch(setProcessSelected(processSelected))
}

const increaseDocumentsUploaded = () => dispatch => {
    dispatch(increaseDocumentsUploadedAction())
}


module.exports = {
    saveProcessSelected,
    increaseDocumentsUploaded,
    resetProcessSelected
};
